export default __webpack_public_path__ + "static/media/bosun.7ef376d2.svg";